(function(){

    angular.module('tmx-app').controller('rulesManagementCtrl', ['$filter','APP_CONSTANTS', '$mdMedia', '$state','RulesService','$mdSidenav','TmxDialogService','CurrentUserService','tmxUtility','menu','ToastService','lookupService','LoanProductService','resolvedData','$location' ,
    
        function RulesManagementCtrl($filter,APP_CONSTANTS, $mdMedia, $state, RulesService, $mdSidenav,TmxDialogService, CurrentUserService,tmxUtility,menu,ToastService,lookupService,LoanProductService,resolvedData,$location){
        // PrivilegesService
            var rulesVM=this;
            var exists;
            var copy;

        // Not sure what is relevant below this:
            rulesVM.EntityName = "RulesManagement";
        
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            rulesVM.checkPermission = tmxUtility.checkPermission;
            rulesVM.query = "Device";
            rulesVM.downloadTemplateOfBatch = downloadTemplateOfBatch;
            rulesVM.gridData = new kendo.data.ObservableArray([]);
            rulesVM.cols = RulesService.gridColumn;
            rulesVM.nav = "SearchSideNav";
            rulesVM.schema = RulesService.schema;
            rulesVM.cloneColumn = RulesService.gridColumn;
            rulesVM.RulesService = RulesService;
            rulesVM.afterImport = afterImport;
            rulesVM.menu = menu;
            rulesVM.statusLookup=undefined;
            rulesVM.Operators = [
                {
                    "VisibleValue": "equal",
                    "HiddenValue": "equal", "LookupId": "equal"
                },{
                    "VisibleValue": "notEqual",
                    "HiddenValue": "notEqual", "LookupId": "notEqual"
                }, {
                    "VisibleValue": "less",
                    "HiddenValue": "less", "LookupId": "less"
                }, {
                    "VisibleValue": "lessOrEqual",
                    "HiddenValue": "lessOrEqual", "LookupId": "lessOrEqual"
                }, {
                    "VisibleValue": "greater",
                    "HiddenValue": "greater", "LookupId": "greater"
                }, {
                    "VisibleValue": "greaterOrEqual",
                    "HiddenValue": "greaterOrEqual", "LookupId": "greaterOrEqual"
                }, {
                    "VisibleValue": "contains",
                    "HiddenValue": "contains", "LookupId": "contains"
                },
                {
                    "VisibleValue": "isNull",
                    "HiddenValue": "isNull", "LookupId": "isNull"
                }]
            ;
            rulesVM.Nodes = [
                {
                    "VisibleValue": "and",
                    "HiddenValue": "and", "LookupId": "and"
                }, {
                    "VisibleValue": "or",
                    "HiddenValue": "or", "LookupId": "or"
                }];
            rulesVM.Statuses = [
                {
                    "VisibleValue": "Status",
                    "HiddenValue": "Status", "LookupId": 1
                }, {
                    "VisibleValue": "Error Messaage",
                    "HiddenValue": "Error Message", "LookupId": 2
                }];
            rulesVM.Products = resolvedData.loanProducts.data;
            rulesVM.commonlookups = resolvedData.commonLookups.lookups;
        // rulesVM.statusLookup=[                
        //         {
        //             LookupId:'1',
        //             VisibleValue:'Rule for Eligible Amount'
        //         }
        //         ,
        //         {
        //             LookupId:'2',
        //             VisibleValue:'Rule for Staff Classification and Designation'
        //         },
        //         {
        //             LookupId:'3',
        //             VisibleValue:'Fee Structure'
        //         }
        //     ];
            rulesVM.cancel = function(){
            //$state.searchClear = true;
                $location.path("/home/dashboard");
            };
            rulesVM.updateStates = function (productId) {
                if ((!(angular.isDefined(productId)) || productId === null)) {
                    rulesVM.vm.States = [];
                    rulesVM.vm.stateId = null;
                    rulesVM.vm.productId = null;
                    rulesVM.States = [];
                    rulesVM.conditions = null;
                    rulesVM.isEnableChip = true;
                    rulesVM.Rules = [];
                //rulesVM.vm.TmxCompanyBranchUsersMapping[0].CompanyBranchId = null;
                    return;
                }


                LoanProductService.getStatesbyProduct(productId).then(
                    function (data) {
                        if(data.data!=null && data.data.length>0) {
                            decorateForSelect(data.data);
                            rulesVM.States = data.data;
                            rulesVM.isEnableChip = false;
                        }
                        else if(rulesVM.vm.productId!=null && angular.isDefined(rulesVM.vm.productId)) {
                            LoanProductService.getRulesbyProduct(rulesVM.vm.productId,null).then(
                                function (data) {
                                    decorateRules(data.data);
                                    rulesVM.Rules = data.data;
                                    rulesVM.isEnableChip = false;
        
                                }
                            );
                        }

                    }
                );
            }
            rulesVM.updateRules = function (stateId) {
                if ((!(angular.isDefined(stateId)) || stateId === null)) {
                    rulesVM.vm.Rules = [];
                    rulesVM.vm.ruleId = null;
                    rulesVM.isEnableChip = true;
                    rulesVM.Rules = [];
                //rulesVM.vm.TmxCompanyBranchUsersMapping[0].CompanyBranchId = null;
                    return;
                }


                LoanProductService.getRulesbyProduct(rulesVM.vm.productId,stateId).then(
                    function (data) {
                        decorateRules(data.data);
                        rulesVM.Rules = data.data;
                        rulesVM.isEnableChip = false;

                    }
                );
            }
            rulesVM.updateXML = function (ruleId) {
                if ((!(angular.isDefined(ruleId)) || ruleId === null)) {
                    rulesVM.vm.XML = [];
                    rulesVM.vm.ruleId = null;
                    rulesVM.isEnableChip = true;
                    rulesVM.conditions = [];
                    return;
                }


                LoanProductService.getRulebyRuleId(ruleId).then(
                    function (data) {
                    //decorateRules(data.data);
                        rulesVM.vm.XML = data;
                        rulesVM.conditions = data.conditions;
                        rulesVM.isEnableChip = false;
                   
                        for(var item=0;item<rulesVM.conditions.length;item++) {
                            if(rulesVM.conditions[item].clauses.length>0) {
                                for(var i=0;i<rulesVM.conditions[item].clauses.length;i++) {
                                    if(rulesVM.conditions[item].clauses[i].LookupType!=null) {
                                        var AreaLkp =  lookupService.getLocalLookupsByType(rulesVM.conditions[item].clauses[i].LookupType);
                                        if(AreaLkp!=null) {
                                        
                                            angular.forEach(AreaLkp,function(type){
                                                type.LookupId = type.VisibleValue;
                                                type.HiddenValue = type.VisibleValue;
                                            });
                                            rulesVM.conditions[item].clauses[i].lookups = AreaLkp;
                                        // rulesVM.conditions[item].clauses[i].lookups.foreach(){
                                        // }
                                        // LookupId = rulesVM.conditions[item].clauses[i].lookups.VisibleValue;
                                        // rulesVM.conditions[item].clauses[i].lookups.HiddenValue = rulesVM.conditions[item].clauses[i].lookups.VisibleValue;
                                        }
                                        else{
                                            angular.forEach(rulesVM.conditions[item].clauses[i].ExpectedValues,function(type){
                                                type.LookupId = type.VisibleValue;
                                                type.HiddenValue = type.VisibleValue;
                                            });
                                            rulesVM.conditions[item].clauses[i].lookups = rulesVM.conditions[item].clauses[i].ExpectedValues;
                                        }
                                  
                            
                                    }
                                    else {
                                        rulesVM.conditions[item].clauses[i].lookups = [{
                                            "VisibleValue":rulesVM.conditions[item].clauses[i].Value,HiddenValue:rulesVM.conditions[item].clauses[i].Value
                                        }];
                                    }
                                }
                            }

                        
                            for(var j=0;j<rulesVM.conditions[item].actions.length;j++)
                                if(rulesVM.conditions[item].actions[j].LookupType!=null) {
                                    var Lkp =  lookupService.getLocalLookupsByType(rulesVM.conditions[item].actions[j].LookupType);
                                    if(Lkp!=null && Lkp.length>0) {
                                    
                                        angular.forEach(Lkp,function(type){
                                            type.LookupId = type.VisibleValue;
                                            type.HiddenValue = type.VisibleValue;
                                        });
                                        rulesVM.conditions[item].actions[j].lookups = Lkp;
                                    }
                                    else{
                                        var expectedLkps = [];
                                        angular.forEach(rulesVM.conditions[item].actions[j].ExpectedValues,function(type){
                                            var expected = {};
                                            expected.LookupId = type;
                                            expected.HiddenValue = type;
                                            expected.VisibleValue = type;
                                            expectedLkps.push(expected);
                                        });
                                        rulesVM.conditions[item].actions[j].lookups = expectedLkps;
                                    }
                                }
                                else {
                                    rulesVM.conditions[item].actions[j].lookups = [{
                                        "VisibleValue":rulesVM.conditions[item].actions[j].Value,HiddenValue:rulesVM.conditions[item].actions[j].Value
                                    }];
                                }
                        }
                    }
                );
            }
            rulesVM.filterValues = function(lookupType,value){
                var filterLookups = [];
                let AreaLkp;
                if(lookupType!=null) {
                    AreaLkp =  lookupService.getLocalLookupsByType(lookupType);
                    if(AreaLkp!=null) {
                        
                        angular.forEach(AreaLkp,function(type){
                            type.LookupId = type.VisibleValue;
                            type.HiddenValue = type.VisibleValue;
                        });
                        filterLookups = AreaLkp;
                        return filterLookups;
                    }
                }
                else {
                    AreaLkp = [{
                        "VisibleValue":value,"HiddenValue":value
                    }];
                    filterLookups = AreaLkp;
                    return filterLookups;
                }
            }
            rulesVM.save = function (action, form) {
                rulesVM.loading = true;
                rulesVM.formSubmitted = true;
                form.$submitted = true;
                rulesVM.postdata = {};
                rulesVM.postdata.name = rulesVM.vm.XML.name;
                rulesVM.postdata.description = rulesVM.vm.XML.description;
                rulesVM.postdata.conditions = rulesVM.vm.XML.conditions;
                rulesVM.postdata.ruleId = rulesVM.vm.ruleId;
                LoanProductService.updateRule(rulesVM.postdata).then(function(response) {
                    if(response.status!=null && response.status.code ==200) {
                        $location.path("/home/dashboard");
                    } 
                    else
                        ToastService.showCustomToast("error", "Some Error Occured");
                });
            };      
                    
            rulesVM.currentTenant = CurrentUserService.getUserObject();
            rulesVM.dataObj = {
                value: "empty"
            };
        // rulesVM.checkPermission = PrivilegesService.checkPermission;
            rulesVM.gridColumns = RulesService.columns;
            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.VisibleValue = obj.VisibleName;
                        obj.HiddenValue = obj.Name;
                    }
                );
            }
            function decorateRules(arrayOfObj) {
                if(arrayOfObj && arrayOfObj!=null && arrayOfObj.length>0) {
                    arrayOfObj.forEach(
                        function (obj) {
                            obj.VisibleValue = obj.RuleName;
                            obj.HiddenValue = obj.ProductRuleId;
                        }
                    );
                }
            }
            function afterImport(response) {

                if (response.data.status.code == 200) {
                    ToastService.showCustomToast("success", "Upload Successful");
                }
                rulesVM.mainGridOptions = {
                    dataSource: {

                        transport: {
                            read: function (o) {
                                if (angular.isDefined(rulesVM.searchClear) && rulesVM.searchClear == false) {
                                    if (exists(rulesVM.o)) {
                                        copy(rulesVM.o.data, ["filter"], o.data);
                                    }
                                }
                                rulesVM.searchClear = false;
                                if (rulesVM.onChildState()) { return; }
                                if (!o.fromSideNav) {
                                    if ($state.searchClear) {
                                        rulesVM.searchClear = true;
                                        $state.searchClear = undefined;
                                    }
                                }
                                else
                                    o.data.firstPage = true;
                                rulesVM.o = angular.copy(o);
                                rulesVM.filters = rulesVM.o.data.filter;

                            //  var promise=RulesService.getByParams(o,true)
                            //   promise.then(function(response){

                                rulesVM.kendoResponse = angular.copy(response.data);
                                if (!angular.isDefined(response.data) || !angular.isDefined(response.data.data))
                                    return;

                                o.success(response.data);
                            //  });

                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sortable: {
                            mode: "multiple",
                            allowUnsort: true
                        },
                        sort: [{ field: "DeviceId", dir: "desc" }]
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: [5, 10, 15, 20, 100, 'All'],
                        pageSize: 15,
                        buttonCount: 4
                    },

                    pdf: {
                        allPages: true,
                        fileName: "Devices.pdf"
                    },
                    excel: {
                        allPages: true,
                        fileName: "Devices.xlsx"
                    },
                    sortable: true,
                    scrollable: !$mdMedia('gt-sm'),
                    columns: RulesService.columns
                };

            }


            rulesVM.container = {};
            $state.data = {
                grid: rulesVM.container,
                info: false

            };

            var monthFormat = buildLocaleProvider("MMM-YYYY");

            function buildLocaleProvider(formatString) {
                return {
                    formatDate: function (date) {
                        if (date) return moment(date).format(formatString);
                        else return null;
                    },
                    parseDate: function (dateString) {
                        if (dateString) {
                            var m = moment(dateString, formatString, true);
                            return m.isValid() ? m.toDate() : new Date(NaN);
                        }
                        else return null;
                    }
                };
            }


            rulesVM.dateFields = {

                type: 'date',
                required: false,
                binding: 'applicant.expectedGraduation',
                startView: 'month',
                label: 'Credit Card Expiry - Year/Month picker',
                locale: monthFormat
            };

            rulesVM.searchSideNavActive = false;
            rulesVM.exportSideNavActive = false;
            rulesVM.allButton = false;
            rulesVM.filt = {};

            rulesVM.EmpLkp = [{ LookupId: 1, VisibleValue: "Techlogix" },
                { LookupId: 2, VisibleValue: "TRG" },
                { LookupId: 3, VisibleValue: "HBL" },
                { LookupId: 4, VisibleValue: "HBL" },
            ];

            rulesVM.MonthLkp = [
                { LookupId: 1, VisibleValue: "Jan2017" },
                { LookupId: 2, VisibleValue: "Feb2017" },
                { LookupId: 3, VisibleValue: "Mar2017" },
                { LookupId: 4, VisibleValue: "Apr2017" },
                { LookupId: 5, VisibleValue: "May2017" },
                { LookupId: 6, VisibleValue: "Jun2017" },
                { LookupId: 7, VisibleValue: "Jul2017" },
                { LookupId: 8, VisibleValue: "Aug2017" },
                { LookupId: 9, VisibleValue: "Sep2017" },
                { LookupId: 10, VisibleValue: "Oct2017" },
                { LookupId: 11, VisibleValue: "Nov2017" },
                { LookupId: 12, VisibleValue: "Dec2017" },
                { LookupId: 13, VisibleValue: "Jan2018" },
                { LookupId: 14, VisibleValue: "Feb2018" },
                { LookupId: 15, VisibleValue: "Mar2018" },
                { LookupId: 16, VisibleValue: "Apr2018" },
                { LookupId: 17, VisibleValue: "May2018" },
                { LookupId: 18, VisibleValue: "Jun2018" },
                { LookupId: 19, VisibleValue: "Jul2018" },
                { LookupId: 20, VisibleValue: "Aug2018" },
                { LookupId: 21, VisibleValue: "Sep2018" },
                { LookupId: 22, VisibleValue: "Oct2018" },
                { LookupId: 23, VisibleValue: "Nov2018" },
                { LookupId: 24, VisibleValue: "Dec2018" },

            ];


            rulesVM.reload = reload;
            rulesVM.checkAddDisabled = checkAddDisabled;
            rulesVM.success = success;
            rulesVM.onChildState = onChildState;
            rulesVM.isOpen = isOpen;
            rulesVM.new = newfunction;
            rulesVM.clickEdit = clickEdit;
            rulesVM.clickView = clickView;
            rulesVM.clickActive = clickActive;
            rulesVM.clickInactive = clickInactive;
            rulesVM.Deactivate = Deactivate;
            rulesVM.Activate = Activate;

            rulesVM.clickDelete = clickDelete;
            rulesVM.isStatusActive = isStatusActive;
            rulesVM.isEditable = isEditable;
            rulesVM.isActive = isActive;
            rulesVM.isInActive = isInActive;
            rulesVM.formatDeviceName = formatDeviceName;
            rulesVM.notPending = notPending;
            rulesVM.status = status;
            rulesVM.getUser = getUser;
            rulesVM.isPending = isPending;
            rulesVM.formatDistributor = formatDistributor;
            rulesVM.formatWarehouse = formatWarehouse;
            rulesVM.formatManufacturer = formatManufacturer;
            rulesVM.formatPhoneNumber = formatPhoneNumber;
            rulesVM.isFiltered = isFiltered;
            rulesVM.selectAll = selectAll;


            rulesVM.toggleSearch = toggleSearch;
            rulesVM.toggleExport = toggleExport;
            rulesVM.toggle = toggle;
            rulesVM.search = search;
            rulesVM.clear = clear;


        //**********functions****************
            function reload() {
                rulesVM.container.rulesGrid.dataSource.read();
            }
            function checkAddDisabled() {
                if ($mdSidenav(rulesVM.nav).isOpen()) {
                    return true;
                }
                else {
                    return false;
                }
            }
            function success(promise) {
                if (promise.read == true) {
                    for (var j = rulesVM.container.rulesGrid.columns.length - 1; j >= 0; j--) {


                        if (angular.isDefined(rulesVM.o.data.filter) && rulesVM.o.data.filter != null) {
                            if (angular.isDefined(rulesVM.o.data.filter.filters) && rulesVM.o.data.filter.filters.length > 0) {
                                for (var i = rulesVM.o.data.filter.filters.length - 1; i >= 0; i--) {
                                    if (rulesVM.o.data.filter.filters[i].field == rulesVM.container.rulesGrid.columns[j].field) {
                                        rulesVM.container.rulesGrid.columns[j].headerTemplate = "<span>" + rulesVM.container.rulesGrid.columns[j].title + "<md-icon >file_download</md-icon></span>";
                                        rulesVM.container.rulesGrid.columns[j].title = "changed";
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    rulesVM.container.rulesGrid.dataSource.read();
                }

            }
            function onChildState() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0 || $state.current.name.indexOf(".info") > 0)
                    return true;
            }
            function isOpen(navID) {
                if (rulesVM.checkPermission('administration.RulesManagement.view'))
                    return $mdSidenav(navID).isOpen();
            }
            function newfunction() {


                if (rulesVM.isOpen('SearchSideNav')) {
                    rulesVM.toggle('SearchSideNav');
                }


                if (rulesVM.isOpen('ExportSideNav')) {
                    rulesVM.toggle('ExportSideNav');
                }


                $state.go($state.current.name + ".add");
            }
            function clickEdit(item) {

                if (rulesVM.checkPermission('administration.RulesManagement.edit')) {
                    $state.data.info = false;
                    $state.go($state.current.name + ".edit", { "Id": item.DeviceId });
                }
            }
            function clickView(item) {

                $state.data.info = true;
                $state.go($state.current.name + ".info", { "Id": item.DeviceId });
            }
            function clickActive(item) {

                var diagConfig = {
                    action: "Activate",
                    entity: $filter('translate')("Device"),
                    entityname: item.DeviceName,
                    details: [
                        { value: item.DeviceName, label: $filter('translate')("Name") },
                        { value: rulesVM.formatPhoneNumber(item), label: $filter('translate')("Phone") },
                        { value: item.DeviceMake, label: $filter('translate')("Manufacturer") }
                    ],
                    options: [
                        { label: $filter('translate')("Activate"), value: true, class: "md-greenery" },
                        { label: $filter('translate')("Cancel"), value: false, class: "md-primary" }
                    ]
                };
                function callback(ok) {
                    if (ok) {
                        rulesVM.Activate(item);
                    }
                }
                var rulesActivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

                rulesActivateDialog.show();

            }
            function clickInactive(item) {

                var diagConfig = {
                    action: "Deactivate",
                    entity: $filter('translate')("Device"),
                    entityname: item.DeviceName,
                    details: [
                        { value: item.DeviceName, label: $filter('translate')("Name") },
                        { value: rulesVM.formatPhoneNumber(item), label: $filter('translate')("Phone") },
                        { value: rulesVM.DeviceMake, label: $filter('translate')("Manufacturer") }
                    ],
                    options: [
                        { label: $filter('translate')("Deactivate"), value: true, class: "md-warn" },
                        { label: $filter('translate')("Cancel"), value: false, class: "md-primary" }
                    ]
                };
                function callback(ok) {
                    if (ok) {
                        rulesVM.Deactivate(item);
                    }
                }
                var rulesDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

                rulesDeactivateDialog.show();
            }
            function Deactivate(item) {
                item.$deactivate(item.DeviceId).then(function () {
                    rulesVM.container.rulesGrid.dataSource.read();
                });
            }

            function Activate(item) {
                item.$activate(item.DeviceId).then(function () {
                    rulesVM.container.rulesGrid.dataSource.read();
                });
            }


        //**********kendo row template functions************

            function clickDelete() {
                // deleteConfirm(item);
            }


        // grey out the row if returned true
            function isStatusActive(dataitem) {
                if (dataitem.Status == "Active") {
                    return true;
                }
                return false;
            }
            function isEditable(dataitem) {
                if (dataitem.Status == "Active" || dataitem.Status == "Pending") {
                    return true;
                }
                return false;
            }

            function isActive(dataitem) {
                if (dataitem.Status == "Active") {
                    return true;
                }
                return false;
            }

            function isInActive(dataitem) {
                if (dataitem.Status == "Inactive") {
                    return true;
                }
                return false;
            }


            function formatDeviceName(dataitem) {
                if (angular.isDefined(dataitem.DeviceName) && dataitem.DeviceName != null)
                    return tmxUtility.sliceText(dataitem.DeviceName, 25);
                else
                    return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }

        // show activate and deactivate option
            function notPending(dataitem) {
                // var endDate = dataitem.EffectiveEndDate.split("T");
                // endDate = endDate[0];
                // var startDate = dataitem.EffectiveStartDate.split("T");
                // startDate = startDate[0];
                // var date = rulesVM.date.split("T");
                let date = date[0];
                if (dataitem.EffectiveStartDate > rulesVM.date) {
                    return false;
                }
                else if (dataitem.EffectiveEndDate >= rulesVM.date && dataitem.EffectiveStartDate <= rulesVM.date) {
                    if (angular.isDefined(dataitem.UserId) && dataitem.UserId != null) {
                        return true;
                    }
                }
                return false;
            }

            function status(dataitem) {

                if (dataitem.Status == "Inactive") {
                    return "Inactive";
                }
                else if (dataitem.Status == "Pending") {
                    return "Pending";
                }
                else if (dataitem.Status == "Active") {
                    return "Active";

                }

            }
            function isPending(status) {
                if (status == "Pending")
                    return true;
                return false;
            }
            function getUser(dataitem) {

                if (dataitem.UserName != null && angular.isDefined(dataitem.UserName != null) && dataitem.UserName != "0") {
                    return dataitem.UserName;
                }

                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }


            function formatDistributor(dataitem) {

                if (dataitem.DistributorName != null && angular.isDefined(dataitem.DistributorName != null) && dataitem.DistributorName != "0") {
                    return dataitem.DistributorName;
                }

                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }

            function formatWarehouse(dataitem) {

                if (dataitem.WarehouseName != null && angular.isDefined(dataitem.WarehouseName != null) && dataitem.WarehouseName != "0") {
                    return dataitem.WarehouseName;
                }

                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }


            function formatManufacturer(dataitem) {
                if (dataitem.DeviceMake != null && dataitem.DeviceModelName != null) {
                    return dataitem.DeviceMake + " " + dataitem.DeviceModelName;
                }
                else if (dataitem.DeviceMake != null && dataitem.DeviceModelName == null) {
                    return dataitem.DeviceMake;
                }
                else if (dataitem.DeviceMake == null && dataitem.DeviceModelName != null) {
                    return dataitem.DeviceModelName;
                }
                else
                    return "N/A";
            }
            function formatPhoneNumber(dataitem) {
                if (angular.isDefined(dataitem.PhoneNumber1) && dataitem.PhoneNumber1 != null && dataitem.PhoneNumber1 != "N/A") {

                    return "+" + dataitem.PhoneNumber1;
                }
                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }
            function isFiltered(fieldName) {
                var filtered = false;

                if (angular.isDefined(rulesVM.filters)) {
                    rulesVM.filters.filters.forEach(function (filterValue) {

                        if (fieldName == filterValue.field) {
                            filtered = true;
                        }

                    });
                }
                return filtered;
            }


            function toggleSearch() {
                if (rulesVM.searchSideNavActive) {
                    rulesVM.searchData = {};
                    rulesVM.searchSideNavActive = false;
                }
                else
                    rulesVM.searchSideNavActive = true;
                rulesVM.toggle('SearchSideNav');
            }

            function toggleExport() {
                if (rulesVM.exportSideNavActive)
                    rulesVM.exportSideNavActive = false;
                else
                    rulesVM.exportSideNavActive = true;
                rulesVM.toggle('ExportSideNav');
            }
            function downloadTemplateOfBatch() {

                // eslint-disable-next-line no-undef
                $window.location.href = "http://localhost:37991/api/v1/uploadtemplates/Batch%20Template.csv";

            }
            function toggle(navID) {
                if (navID != 'ExportSideNav' && rulesVM.isOpen('ExportSideNav')) {
                    $mdSidenav('ExportSideNav').toggle();
                }
                if (navID != 'SearchSideNav' && rulesVM.isOpen('SearchSideNav')) {
                    $mdSidenav('SearchSideNav').toggle();
                }
                if (navID != 'ImportSideNav' && rulesVM.isOpen('ImportSideNav')) {
                    $mdSidenav('ImportSideNav').toggle();
                }
                $mdSidenav(navID).toggle();
            }


            function search(navID) {

                var calls = [];


                for (var key in rulesVM.searchData) {
                    if (rulesVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: rulesVM.searchData[key]
                        });
                    }
                }

                rulesVM.filt = {
                    filters: calls,
                    logic: "and"
                };

                rulesVM.o.data.filter = rulesVM.filt;
                rulesVM.container.rulesGrid.dataSource.transport.read();

                rulesVM.searchData = {};
                rulesVM.toggle(navID);
            }

            function selectAll() {
                for (var i = 0; i < rulesVM.container.rulesGrid._data.length; i++) {

                    rulesVM.container.rulesGrid._data[i].selected = !rulesVM.allButton;

                }
            }
            function clear(navID) {
                rulesVM.searchData = {};
                rulesVM.toggle(navID);
            }

        }]);

})();
